import React from 'react';
import cn from 'clsx';

import styles from './chip.scss';

interface ChipProps {
  children: React.ReactNode;
  className?: string;
}

function Chip(props: ChipProps) {
  const { children, className = '' } = props;

  return (
    <span className={cn(styles['container'], `chip ${className}`)}>
      {children}
    </span>
  );
}

export default Chip;
